import { BodyText, Heading } from '@farol-ds/react'

import { JusAILogo } from '../jus-ia-brand'
import styles from './jusia-insights.module.scss'

export interface JusIAInsightsProps {
  totalDocs: number
}

export function JusIAInsights({ totalDocs }: JusIAInsightsProps) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <JusAILogo width={24} height={24} />
        <Heading size="md" className={styles.title} asChild>
          <h2>Jurisprudência selecionada pelo Jus IA</h2>
        </Heading>
      </div>

      <BodyText size="lg" className={styles.description}>
        O Jusbrasil processou um grande volume de casos e selecionou{' '}
        <strong>{totalDocs} julgados</strong> que se alinham a essa interpretação. A seguir, vamos
        abordar os julgados que corroboram a tese.
      </BodyText>
    </div>
  )
}
